import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./style/HousekeepingLanding.css";
import TestimonialSection from "./TestimonialSection";
import FAQSection from "./FAQSection";

const services = [
  {
    title: "Residential Cleaning",
    description: 'Deep cleaning and sanitization services for homes and apartments.',
    image: "/assets/houseresidential.webp",
  },
  {
    title: "Commercial Cleaning",
    description: 'Routine and intensive cleaning solutions for offices and shops.',
    image: "/assets/cleaning.jpg",
  },
  {
    title: "Industrial Cleaning",
    description: 'We Provide Heavy-duty cleaning for warehouses and industrial units.',
    image: "/assets/comhouse.webp",
  },
];

export default function HousekeepingLanding() {   
  const [formData, setFormData] = useState({ name: "", phone: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Client-side validation
    if (!formData.name.trim()) {
      toast.error("Please enter your name");
      return;
    }

    if (!formData.phone.trim()) {
      toast.error("Please enter your phone number");
      return;
    }

    const phoneRegex = /^[0-9]{10,15}$/;
    if (!phoneRegex.test(formData.phone)) {
      toast.error("Please enter a valid phone number (10 to 15 digits)");
      return;
    }

    try {
      const response = await fetch(
        "https://shalishaenterprise.com/backend/submit_form.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      if (response.ok && data.apiresponse?.code === "0000") {
        toast.success(data.apiresponse.message || "Message sent successfully!");
        setFormData({ name: "", phone: "" });

        setTimeout(() => {
          window.location.href =
            "https://shalishaenterprise.com/backend/thank_you.php";
        }, 2000);
      } else {
        toast.error(data.apiresponse?.message || "Failed to send message");
      }
    } catch (err) {
      toast.error("An error occurred. Please try again.");
      console.error("Form error:", err);
    }
  };

  return (
    <>
      <section
        id="enquiry"
        className="slider"
        style={{
          backgroundImage: `url("./assets/housekeeping.webp")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-8">
          <ToastContainer />
              <div className="slide__content text-white">
                <h2 className="slide__title">
                  Housekeeping Services<br />
                </h2>
                <p className="slide__desc">
                  Maintain spotless spaces with our expert cleaning staff. Book a free consultation today!
                </p>
              </div>
            </div>

            <div className="col-sm-4 col-md-4 mobileview">
              <div className="intro-form bg-white p-4 rounded shadow">
                <h4>Book Your Cleaning Service</h4>
                <form onSubmit={handleSubmit} noValidate> {/* ✅ no action here */}
                  <fieldset>
                    <input
                      placeholder="Name"
                      required
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-control mb-2"
                    />
                    <input
                      placeholder="Mobile No."
                      required
                      type="tel"
                      name="phone"
                      className="form-control mb-3"
                      minLength="10"
                      maxLength="15"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                    <button
                      className="btn btn-block btn-lg btn-orange"
                      type="submit"
                    >
                      Submit Now
                    </button>
                  </fieldset>
                </form>

              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="housekeeping-section text-white py-5">
        <div className="container">
          <h2 className="section-heading text-center mb-5">
            Complete Housekeeping Solutions
          </h2>
          <div className="row">
            {services.map((service, index) => (
              <div className="col-lg-4 col-md-6 mb-4" key={index}>
                <div className="service-card">
                  <div className="service-image-wrapper" data-aos="zoom-in">
                    <img src={service.image} alt={service.title} className="img-fluid" />
                  </div>
                  <div className="service-info">
                    <h5 className="service-title text-center">{service.title}</h5>
                    <p className="service-description text-center">{service.description}</p>
                    <a href="#enquiry" className="btn btn-sm w-100 btn-housekeeping p-2">
                      Send Enquiry
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <TestimonialSection />
      <FAQSection />
    </>
  );
}
